import React from 'react';
import MenuButton, { MenuButtonItem } from 'components/MenuButton';
import Icon from 'components/base/Icon';

const EditDeleteMenuButton = ({ onEdit, onDelete, hideBorder, size }) => (
  <MenuButton
    data-html2canvas-hide='true'
    buttonVariant='ghost'
    width='20rem'
    padding='x-x-x-small'
    hideBorder={hideBorder}
    size={size}
    onClick={e => {
      e.preventDefault();
      e.stopPropagation();
    }}
    items={[
      <MenuButtonItem
        key='Edit Project'
        text='Edit Project'
        icon={<Icon name='pencil' color='nepal' size='smaller' />}
        onClick={e => {
          e.stopPropagation();
          e.preventDefault();
          onEdit();
        }}
      />,
      <MenuButtonItem
        key='Delete Project'
        text='Delete Project'
        data-cy='delete-project'
        icon={<Icon name='Trash' color='nepal' size='smaller' />}
        onClick={e => {
          e.stopPropagation();
          e.preventDefault();
          onDelete();
        }}
      />
    ]}
  />
);

export default EditDeleteMenuButton;
